import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';

import {environment} from 'environments/environment';
import {UsefulLink} from 'app/models/useful-link';
import {CompetitionService} from 'app/services/competition.service';
import {UPTOPResult} from 'app/models/uptop';
import {Router} from '@angular/router'
@Injectable({
    providedIn: 'root'
})
export class UsefulLinkService {

    private apiUrl = environment.api.url + environment.api.content.url;

    constructor(private http: HttpClient, private competitionService: CompetitionService, private router: Router) {}

    getAll(lastEvaluatedKey?: any): Observable<UPTOPResult> {
        let params = new HttpParams();
        params = params.append('competition', this.competitionService.getCompetitionId());
        params = params.append('op', environment.api.content.type.assets.op);
        params = params.append('source', environment.api.content.type.assets.usefulLink);
        if (this.router.url.split('/').filter(s => s).length <= 1) {
            params = params.append("view", "user");
        }
        let headers = new HttpHeaders();
        if (lastEvaluatedKey) {
            headers = headers.append('lastevaluatedkey', btoa(JSON.stringify(lastEvaluatedKey)));
        }

        return this.http
            .get<UPTOPResult>(this.apiUrl, {headers, params})
            .pipe(
                map((res) => res as UPTOPResult),
                catchError((err) => throwError(err || 'ServerErr'))
            );
    }

    create(usefulLink: UsefulLink): Observable<UsefulLink> {
        return this.http
            .post<UsefulLink>(this.apiUrl, usefulLink)
            .pipe(
                map(res => <UsefulLink> res),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    update(usefulLink: UsefulLink): Observable<UsefulLink> {
        return this.http
            .put<UsefulLink>(this.apiUrl, usefulLink)
            .pipe(
                map(res => <UsefulLink> res),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }

    delete(id: string): Observable<UsefulLink> {
        let params = new HttpParams();
        params = params.append('op', environment.api.content.type.assets.op);
        params = params.append('element', id);

        return this.http
            .delete<UsefulLink>(this.apiUrl, {params})
            .pipe(
                map(res => <UsefulLink> res),
                catchError(err => throwError(err || 'ServerErr'))
            );
    }
}
